import React from 'react';
import { useTranslation } from 'react-i18next';


interface StatsMonthGridProps {
  year: number;
  onMonthSelect: (year: number, month: number) => void;
  onYearChange: (year: number) => void;
}

export const StatsMonthGrid: React.FC<StatsMonthGridProps> = ({
  year,
  onMonthSelect,
  onYearChange
}) => {
  const { t, i18n } = useTranslation();

  // Русские месяцы (короткие)
  const ruMonthsShort = [
    '', 'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
    'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'
  ];

  // Английские месяцы (короткие)
  const enMonthsShort = [
    '', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const monthsShort = i18n.language === 'ENG' ? enMonthsShort : ruMonthsShort;

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const handleMonthClick = (month: number) => {
    onMonthSelect(year, month);
  };

  const handlePrevYear = () => {
    // Ограничиваем навигацию до 2025 года
    if (year > 2025) {
      onYearChange(year - 1);
    }
  };

  const handleNextYear = () => {
    onYearChange(year + 1);
  };

  // Создаем сетку месяцев 4x3
  const monthGrid = [];
  for (let i = 1; i <= 12; i += 4) {
    const row = [];
    for (let j = 0; j < 4; j++) {
      const month = i + j;
      if (month <= 12) {
        const isCurrentMonth = year === currentYear && month === currentMonth && year >= 2025;
        row.push(
          <button
            key={month}
            onClick={() => handleMonthClick(month)}
            className={`
              flex-1 p-3 rounded-lg border border-border transition-colors focus:outline-none focus:ring-0
              ${isCurrentMonth
                ? 'bg-primary text-primary-foreground font-bold border-primary' // Текущий месяц
                : 'bg-header text-white' // Обычный месяц
              }
            `}
          >
            {isCurrentMonth ? `[${monthsShort[month]}]` : monthsShort[month]}
          </button>
        );
      }
    }
    monthGrid.push(
      <div key={i} className="grid grid-cols-4 gap-2">
        {row}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Навигация по годам */}
      <div className="flex items-center justify-between">
        <button
          onClick={handlePrevYear}
          className="w-8 h-8 text-sm rounded-md transition-colors border border-border text-textSecondary focus:outline-none focus:ring-0 flex items-center justify-center"
        >
          &lt;
        </button>
        
        <div className={`
          text-lg font-semibold
          ${year === currentYear ? 'text-primary' : 'text-white'}
        `}>
          {year}
        </div>
        
        <button
          onClick={handleNextYear}
          className="w-8 h-8 text-sm rounded-md transition-colors border border-border text-textSecondary focus:outline-none focus:ring-0 flex items-center justify-center"
        >
          &gt;
        </button>
      </div>

      {/* Сетка месяцев */}
      <div className="space-y-2">
        {monthGrid}
      </div>


    </div>
  );
}; 